// extracted by mini-css-extract-plugin
export default {"Placeholder":"waitView_Placeholder__kMivT","WatiingRender":"waitView_WatiingRender__4vy3l","Mask":"waitView_Mask__D3jVj"};